import { useTranslation } from "react-i18next";

export default function KpiGrid({ kpis, yesno }) {
  const { t } = useTranslation();

  const cards = [
    { label: t("dashboard.totalSurveys", "Total d’enquestes"), value: kpis?.totalSurveys ?? "—" },
    { label: t("dashboard.activeCenters", "Centres actius"), value: kpis?.activeCenters ?? "—" },
    {
      label: t("dashboard.avgSoilTemp", "Temperatura mitjana del sòl"),
      value: kpis?.tempSoil_mean != null ? kpis.tempSoil_mean.toFixed(2) : "—",
    },
    {
      label: t("dashboard.avgPh", "pH mitjà"),
      value: kpis?.ph_mean != null ? kpis.ph_mean.toFixed(2) : "—",
    },
    {
      label: t("dashboard.animalsYesPct", "Animals (Sí %)"),
      value:
        kpis?.coverage?.animals_yes_pct != null
          ? `${kpis.coverage.animals_yes_pct.toFixed(2)}%`
          : "—",
    },
    {
      label: t("dashboard.wasteYesPct", "Residus (Sí %)"),
      value:
        kpis?.coverage?.waste_yes_pct != null
          ? `${kpis.coverage.waste_yes_pct.toFixed(2)}%`
          : "—",
    },
    {
      label: t("dashboard.vegetationYesPct", "Vegetació (Sí %)"),
      value:
        yesno?.bloc2_vegetation?.yes_pct != null
          ? `${yesno.bloc2_vegetation.yes_pct}%`
          : "—",
    },
    {
      label: t("dashboard.waterYesPct", "Aigua (Sí %)"),
      value:
        yesno?.bloc7_waterBool?.yes_pct != null
          ? `${yesno.bloc7_waterBool.yes_pct}%`
          : "—",
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
      {cards.map((c) => (
        <div key={c.label} className="bg-white border border-gray-200 rounded-xl p-4">
          <div className="text-xs text-gray-600">{c.label}</div>
          <div className="text-2xl font-semibold mt-1">{c.value}</div>
        </div>
      ))}
    </div>
  );
}